import { Config } from '../config';
import { ModelOption } from '../interfaces';
import { HttpService } from './http.service';

interface OTARepositoryResponse {
  images: unknown[];
  packages: unknown[];
  models: ModelOption[];
}

export abstract class ModelRegistryService {
  public static getModels = (kind?: string): Promise<ModelOption[]> => {
    const params = new URLSearchParams();
    
    if (kind) {
      params.append('kind', kind);
    }

    const queryString = params.toString() ? `?${params.toString()}` : '';

    return HttpService.fetchAuthorized(`${Config.APIv2}/config/ota/repository${queryString}`).then(
      (res: OTARepositoryResponse) => res?.models || [],
    );
  };
}
